import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

export default function FormikFileInput({
  accept,
  formatValue,
  id,
  name,
  required,
  setStatusOnError,
  validate,
}) {
  const {
    handleBlur,
    isSubmitting,
    isValid,
    setFieldError,
    setFieldValue,
    setStatus,
  } = useFormikContext();
  const handleChange = (event) => {
    event.preventDefault();

    const { target } = event;
    const { name: targetName } = target;

    const error = validate(target);
    if (error) {
      setFieldError(targetName, error);
      if (setStatusOnError) {
        setStatus({ [targetName]: error });
      }
      return;
    }

    const [file] = target.files;
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const { result } = reader;
      setFieldValue(targetName, formatValue(file, result));
    });

    reader.readAsDataURL(file);
  };

  return (
    <input
      accept={accept}
      aria-invalid={!isValid}
      disabled={isSubmitting}
      id={id}
      name={name}
      onChange={handleChange}
      onBlur={handleBlur}
      required={required}
      type="file"
    />
  );
}

FormikFileInput.propTypes = {
  accept: PropTypes.string.isRequired,
  formatValue: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  setStatusOnError: PropTypes.bool,
  validate: PropTypes.func,
};

FormikFileInput.defaultProps = {
  formatValue: (file, result) => ({ file: result, ...file }),
  required: false,
  setStatusOnError: false,
  validate: () => {},
};
